import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const anxiety = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
